import React from "react";
import { Form } from "antd";
import TrebbleConfigProvider from "./ConfigProvider";
import useDefaultTrebbleAntDTokenConfig from "../helper/useDefaultTrebbleAntDTokenConfig";

// Form props are complex, inferring is best
interface TrebbleFormProps extends React.ComponentProps<typeof Form> {
  useEditorTheme?: boolean;
}

const TrebbleFormComponent = ({ useEditorTheme, ...restProps }: TrebbleFormProps) => {
  const themeConfig = useDefaultTrebbleAntDTokenConfig({ useEditorTheme });

  return (
    <TrebbleConfigProvider theme={themeConfig} useEditorTheme={useEditorTheme}>
      <Form {...restProps} />
    </TrebbleConfigProvider>
  );
};

// Re-exporting sub-components and hooks
TrebbleFormComponent.Item = Form.Item;
TrebbleFormComponent.List = Form.List;
TrebbleFormComponent.ErrorList = Form.ErrorList;
TrebbleFormComponent.useForm = Form.useForm;
TrebbleFormComponent.useWatch = Form.useWatch;
TrebbleFormComponent.useFormInstance = Form.useFormInstance;

// Type assertion
const TrebbleForm = TrebbleFormComponent as typeof TrebbleFormComponent & {
    Item: typeof Form.Item;
    List: typeof Form.List;
    ErrorList: typeof Form.ErrorList;
    useForm: typeof Form.useForm;
    useWatch: typeof Form.useWatch;
    useFormInstance: typeof Form.useFormInstance;
};

export default TrebbleForm; 